import React from "react";
import styles from "./Hero.module.css";
import Icon from "../common/Icon";
import { Reveal } from "../common/Reveal";
import heroBg from "../../../../images/hero.jpg";

export default function Hero() {
  return (
    <section className={styles.hero} id="home">
      <div className={styles.heroBg} style={{ backgroundImage: `url(${heroBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }} aria-hidden="true" />
      <div className={styles.heroOverlay} aria-hidden="true" />
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>
          <Reveal as="span" className={styles.heroTitleLineWrap}>
            <span>Think Big.</span>{" "}
            <span className={styles.heroTitleAccent}>We do.</span>
          </Reveal>
        </h1>
        <Reveal delay={120} className={styles.heroRule} aria-hidden="true" />
        <Reveal as="p" delay={200} className={styles.heroSubtitle}>
          We call it <strong>passion for automation</strong>
        </Reveal>
        <Reveal delay={320}>
           <a href="/product" className={styles.btnPrimary}>
            Our products <Icon.ChevronRight />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
